import state from './moduleWalletStatusState.js'
import mutations from './moduleWalletStatusMutations.js'
import actions from './moduleWalletStatusActions.js'
import getters from './moduleWalletStatusGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
